import { useFormContext, Controller } from 'react-hook-form';
import { Switch, SwitchProps, Typography, FormControlLabel } from 'material-hu';

type Props = SwitchProps & {
  label?: string;
  subLabel?: string;
};

function FormSwitch(props: Props) {
  const { control } = useFormContext();
  const { name, label, subLabel, ...other } = props;

  return (
    <FormControlLabel
      control={
        <Controller
          render={({ field }) => (
            <Switch
              {...field}
              {...other}
              checked={!!field.value}
              defaultValue={field.value}
            />
          )}
          name={name}
          control={control}
        />
      }
      label={
        label && (
          <div>
            <Typography
              gutterBottom
              variant="subtitle2"
            >
              {label}
            </Typography>
            {subLabel && (
              <Typography
                color="textSecondary"
                variant="body2"
              >
                {subLabel}
              </Typography>
            )}
          </div>
        )
      }
    />
  );
}

export default FormSwitch;
